export const documentProps = {
  title: 'Pricing — Business Automation Packages Starting at $3,000',
  description:
    'Launch ($3K one-time), Optimize ($8K one-time), or Operate ($500–$1,500/month). Transparent pricing, no hidden fees. See what is included in each package.',
};
